import { combineReducers } from 'redux';
import LoyaltyProgramsReducer from './LoyaltyProgramsReducer';
import RestaurantsReducer from './RestaurantsReducer';
import MembersReducer from './MembersReducer';
import CampaignsReducer from './CampaignsReducer';
import BenefitsReducer from './BenefitsReducer';
import ReportsReducer from './ReportsReducer';

export default combineReducers({
    loyaltyPrograms: LoyaltyProgramsReducer, 
    restaurants: RestaurantsReducer,
    members: MembersReducer,
    campaigns: CampaignsReducer,
    benefits: BenefitsReducer,
    reports: ReportsReducer,
});
